module.exports = __webpack_public_path__ + "img/pdf-icon-peach.f6df4993.png";